import React from 'react';

import { RouteInterface } from 'routes';
import GenericListRoute from 'routes/generic/list';

import { DenormalizedDefinition } from 'store/data';

interface Props {
  routes: RouteInterface[];
}

const List: React.FC<Props> = ({ routes }) => {
  return (
    <GenericListRoute<DenormalizedDefinition>
      resolver="definitions"
      itemName="definition"
      listItemTitle={entity => entity.name}
      listTitle="Definitions"
      detailRoute="definition"
      detailIdParam="definitionId"
      createRoute="definitions:create"
      dependencies={[]}
      routes={routes}
      showListTitle={true}
    />
  );
};

export default List;
